import React, { useContext, useState, useEffect } from 'react';
import { Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button } from '@mui/material';
import { SchoolContex } from '../../Helper/Contex';
import api from '../../API/api';

import { useNavigate } from 'react-router-dom'

const htmlToFormattedText = require("html-to-formatted-text");

function PublicationCard() {
    const { schools, courses } = useContext(SchoolContex)

    const navigate = useNavigate();

    const [blogs, setBlogs] = useState([{
        title : 'eren yeager',
        details : ' lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum  lorem ipsum ',
        date : '12-02-2033'
    }]);

    useEffect(() => {
        getBlogs()
    }, [])

    const getBlogs = () => {
        // api.getBlogs().then((res) => {
        //     console.log(res);
        //     setBlogs(res.data.blogs)
        // })
        //     .catch((err) => {
        //         console.log(err.response);
        //     })
    }


    return (
        <>
            <div className='my-2'>
                <div className="row m-0 p-0">
                    <div className="col-md-12">
                        <Paper elevation={3}>
                            <div className='row p-3'>

                                {blogs && blogs.map((b) =>
                                (
                                    <div className="col-md-4 p-2">
                                        <Paper elevation={3}>
                                            <div>
                                                <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${b.cover}`} className='col-12' alt={b.title} />
                                            </div>
                                            <div className='m-2 p-2'>

                                                <div>
                                                    <small> <CalendarMonthIcon fontSize='small' /> {b.date}</small>
                                                </div>
                                                <div>
                                                    <Link to={`/blogs/${b.slug}`}><b> {b.title} </b></Link>
                                                </div>
                                                <div className='my-2'>
                                                    <small>
                                                    {htmlToFormattedText(b.details).slice(0, 200)} ... 
                                                        <Link>Read more..</Link>
                                                    </small>
                                                </div>
                                                <div>

                                                </div>
                                            </div>
                                        </Paper>
                                    </div>
                                ))}

                            </div>
                        </Paper>
                    </div>
                </div>

            </div>
        </>
    )
}

export default PublicationCard;